import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ParticleCanvas from './components/ParticleCanvas';
import Home from './pages/Home';
import Services from './pages/Services';
import CaseStudies from './pages/CaseStudies';
import OpenSource from './pages/OpenSource';
import Resources from './pages/Resources';
import Blog from './pages/Blog';
import About from './pages/About';
import Contact from './pages/Contact';
import BlogArchitecture from './pages/BlogArchitecture';
import BlogAIWorkflows from './pages/BlogAIWorkflows';
import BlogDjangoVsFastAPI from './pages/BlogDjangoVsFastAPI';
import BlogReliableAPIs from './pages/BlogReliableAPIs';
import ChatbotWidget from './components/ChatbotWidget';
import BlogAutomation from './pages/BlogAutomation';
import IPTools from './pages/IPTools';
import DevTools from './pages/DevTools';
import FileTools from './pages/FileTools';
import ToolsLanding from './pages/ToolsLanding';
import { HelmetProvider } from 'react-helmet-async';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

export default function App() {
  return (
<HelmetProvider>
      <ParticleCanvas />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/open-source" element={<OpenSource />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog/backend-architecture" element={<BlogArchitecture />} />
          <Route path="/blog/django-vs-fastapi" element={<BlogDjangoVsFastAPI />} />
          <Route path="/blog/automation" element={<BlogAutomation />} />

          <Route path="/blog/ai-workflows" element={<BlogAIWorkflows />} />
          <Route path="/blog/building-reliable-apis" element={<BlogReliableAPIs />} />
          <Route path="/blog/business-automation" element={<BlogAutomation />} />
          <Route path="/tools/ip" element={<IPTools />} />

          <Route path="/tools/ip/:toolName" element={<IPTools />} />
          <Route path="/tools/dev" element={<DevTools />} />
          <Route path="/tools" element={<ToolsLanding />} />

          <Route path="/tools/dev/:toolName" element={<DevTools />} />
          <Route path="/tools/files" element={<FileTools />} />
          <Route path="/tools/files/:toolName" element={<FileTools />} />


        </Routes>
      </main>
      {/* <ChatbotWidget/> */}
      <Footer />
    </HelmetProvider>
  );
}
